/* global React, Button, Icon, Modal, Field, Input, t */

function ResetAllDataConfirmModal({ busy, onConfirm, onClose, i18nPrefix = 'sd' }) {
  const [confirmation, setConfirmation] = React.useState('');
  const shortcut = i18nPrefix === 'demoReset';
  const copy = shortcut ? {
    title: t('demoReset.title'), phrase: t('demoReset.phrase'), confirm: t('demoReset.confirm'),
    message: t('demoReset.message'), preserved: t('demoReset.preserved'),
    typeLabel: (phrase) => t('demoReset.typeLabel', { phrase }), typeHint: t('demoReset.typeHint'),
  } : {
    title: t('set.data.resetAll'), phrase: t('sd.resetPhrase'), confirm: t('sd.resetConfirm'),
    message: t('sd.resetMessage'), preserved: t('sd.resetPreserved'),
    typeLabel: (phrase) => t('sd.resetTypeLabel', { phrase }), typeHint: t('sd.resetTypeHint'),
  };
  const phrase = copy.phrase;
  const confirmed = confirmation.trim() === phrase;
  const close = busy ? () => {} : onClose;
  const run = async () => {
    if (!confirmed) return;
    try { await onConfirm(); onClose(); } catch (error) { /* handler shows the error */ }
  };
  return <Modal open onClose={close} title={copy.title} max={520} className="confirm-modal"
    footer={<React.Fragment>
      <Button variant="ghost" disabled={busy} onClick={close}>{t('common.cancel')}</Button>
      <Button variant="danger-solid" icon="trash" disabled={busy || !confirmed} onClick={run} data-help={t('helpTopics.resetData.body')} data-help-title={t('helpTopics.resetData.title')}>{busy ? t('common.working') : copy.confirm}</Button>
    </React.Fragment>}>
    <div className="col gap-16">
      <div className="row gap-12" style={{ alignItems: 'flex-start' }}>
        <div className="confirm-modal-icon"><Icon name="alertTri" size={20}/></div>
        <div className="col gap-8">
          <p className="t-body" style={{ margin: '4px 0 0' }}>{copy.message}</p>
          <p className="t-sm muted" style={{ margin: 0 }}>{copy.preserved}</p>
        </div>
      </div>
      <Field label={copy.typeLabel(phrase)} hint={copy.typeHint} help={t('helpTopics.resetData.body')} helpTitle={t('helpTopics.resetData.title')}>
        <Input autoFocus autoComplete="off" value={confirmation} disabled={busy} onChange={(event) => setConfirmation(event.target.value)} placeholder={phrase}/>
      </Field>
    </div>
  </Modal>;
}

Object.assign(window, { ResetAllDataConfirmModal });
